export const FETCH_CATEGORIES_START = 'FETCH_CATEGORIES_START';
export const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_FAILED = 'FETCH_CATEGORIES_FAILED';

export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_CURRENT_TAG = 'SET_CATEGORIES';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const ADD_VIDEO_OBJECT_START = 'ADD_VIDEO_OBJECT_START';
export const ADD_VIDEO_OBJECT_SUCCESS = 'ADD_VIDEO_OBJECT_SUCCESS';
export const ADD_VIDEO_OBJECT_FAILED = 'ADD_VIDEO_OBJECT_FAILED';

export const FETCH_USER_DATA_START = 'FETCH_USER_DATA_START';
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS';
export const FETCH_USER_DATA_FAILED = 'FETCH_USER_DATA_FAILED';

export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_TOTAL_USERS = 'SET_TOTAL_USERS';

export const UPDATE_USER_DATA_START = 'UPLOAD_USER_DATA_START';
export const UPDATE_USER_DATA_SUCCESS = 'UPLOAD_USER_DATA_SUCCESS';
export const UPDATE_USER_DATA_FAILED = 'UPLOAD_USER_DATA_FAILED';

export const ADD_TO_PLAYLIST = 'ADD_TO_PLAYLIST';
export const REMOVE_FROM_PLAYLIST = 'REMOVE_FROM_PLAYLIST';

export const UPLOAD_VIDEO_START = 'UPLOAD_VIDEO_START';
export const UPLOAD_VIDEO_SUCCESS = 'UPLOAD_VIDEO_SUCCESS';
export const UPLOAD_VIDEO_FAILED = 'UPLOAD_VIDEO_FAILED';

export const SET_BLOGS = 'SET_BLOGS';

export const FETCH_BLOGS_START = 'FETCH_BLOGS_START';
export const FETCH_BLOGS_SUCCESS = 'FETCH_BLOGS_SUCCESS';
export const FETCH_BLOGS_FAILED = 'FETCH_BLOGS_FAILED';

export const FETCH_REQUESTS_START = 'FETCH_REQUESTS_START';
export const FETCH_REQUESTS_SUCCESS = 'FETCH_REQUESTS_SUCCESS';
export const FETCH_REQUESTS_FAILED = 'FETCH_REQUESTS_FAILED';
export const SET_REQUESTS = 'SET_REQUESTS';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
